import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accueuil',
  templateUrl: './accueuil.component.html',
  styleUrls: ['./accueuil.component.scss']
})
export class AccueuilComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
